import { useState } from "react";
import { formatPlanBytes, PLANS } from "@saucer/core";
import { signInUrl } from "../api.js";
import { navigate } from "../router.js";

const MESSAGES: Record<string, string> = {
  state: "That sign-in attempt expired. Try again.",
};

/**
 * Signup is open — GitHub is the only thing anyone needs. The invite field is
 * still here because codes are still handed out and still record who brought
 * an account in; it just no longer gates anything, so it stays folded away.
 */
export function Login() {
  const [invite, setInvite] = useState("");
  const [showInvite, setShowInvite] = useState(false);
  const error = new URLSearchParams(window.location.search).get("error");

  return (
    <main className="login">
      <p className="kicker">Sign in</p>
      <h1 className="docs__title">Start with your GitHub account.</h1>
      <p className="landing__lede">
        Your username becomes your namespace — every link you share lives at saucer.sh/you/…. New
        accounts start on the free plan with {formatPlanBytes(PLANS.free.storageBytes)} of storage and
        unlimited bandwidth. No card, no invite.
      </p>

      {error ? (
        <p className="notice notice--error">{MESSAGES[error] ?? "Sign-in failed."}</p>
      ) : null}

      <form
        className="stack"
        style={{ marginTop: "1.5rem" }}
        onSubmit={(event) => {
          event.preventDefault();
          window.location.href = signInUrl(invite);
        }}
      >
        {showInvite ? (
          <label className="field">
            <span className="meta">Invite code (optional)</span>
            <input
              className="input mono code-input"
              value={invite}
              onChange={(event) => setInvite(event.target.value)}
              placeholder="xxxx-xxxx-xxxx"
              autoComplete="off"
              spellCheck={false}
              autoFocus
            />
          </label>
        ) : null}

        <div className="row">
          <button className="button button--primary" type="submit">
            Continue with GitHub
          </button>
          {showInvite ? null : (
            <button
              className="button button--quiet"
              type="button"
              onClick={() => setShowInvite(true)}
            >
              I have an invite code
            </button>
          )}
        </div>
      </form>

      <p className="meta" style={{ marginTop: "1.5rem" }}>
        Need more room?{" "}
        <a
          href="/pricing"
          onClick={(event) => {
            event.preventDefault();
            navigate("/pricing");
          }}
        >
          See the plans
        </a>
        .
      </p>
    </main>
  );
}
